<template>
  <div class="imageList">
    <div class="bot" v-if="imageList && imageList.length > 0">
      <div
        class="bot_item"
        v-for="(val, key) in imageList"
        :key="key + 'item'"
      >
        <img :src="val" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "imageList",
  components: {},
  props: ["imgList"],
  data() {
    return {
      imageList: [],
    };
  },
  created() {},
  mounted() {
    this.imageList = this.imgList;
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.imageList {
  width: 100%;
  @include flex_box(column, none, stretch);
  box-sizing: border-box;
  .bot {
    width: 100%;
    @include flex_box(row, flex-start, center);
    overflow-x: scroll;
    margin-bottom: 0.2rem;
  }
  .bot_item {
    width: 1.88rem;
    margin-right: 0.16rem;
    img {
      width: 1.88rem;
      height: auto;
      vertical-align: text-top;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/imageList.vue